import { SET_AUDIENCE_FILTER, CLEAR_AUDIENCE_FILTER } from "./actions.types";

export interface IAudienceFilterState {
  hearingNumber: string;
  startDate: string | null | undefined;
  finishDate: string | null | undefined;
  activeFilter: boolean | null;
  valueOptionDropDown: any;
  isCountyFilter: boolean;
  hearingTypeIdFilter: number | null;
  hearingSourceIdFilter?: number | null;
  statusFilter: string | null;
  attendantFilterId: number | null;
  isFilterActive: boolean;
  userId: number | null;
}

export const setAudienceFilter = (filter: IAudienceFilterState) => {
  return {
    type: SET_AUDIENCE_FILTER,
    payload: filter,
  };
};

export const clearAudienceFilter = () => {
  return {
    type: CLEAR_AUDIENCE_FILTER,
  };
};
